module.exports = __webpack_public_path__ + "assets/tDbV2oqRg1oM3QBjjcaDkOJGiRD7OwE-d5e363.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/tDbV2oqRg1oM3QBjjcaDkOJGiRD7OwE.woff2
// module id = 864
// module chunks = 2